import React from "react";

export const GlobalFilter = ({filter,setFilter}) => {
    return (
        <span style={{marginBottom:'5px'}}>
            <label style={{marginLeft:'15px'}}></label>Search:{' '}
            <input value={filter || ''} onChange={(e) => setFilter(e.target.value) } />
        </span>
    )
}